import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';
import { useAuth } from '../AuthContext';
import api from '../api';

export default function LanguageToggle() {
  const { i18n, t } = useTranslation();
  const { user, updateUser } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = async (lng) => {
    i18n.changeLanguage(lng);
    handleClose();

    // Save preference to database if user is logged in
    if (user) {
      try {
        await api.patch('/auth/language', { language: lng });
        updateUser({ ...user, language: lng });
      } catch (error) {
        console.error('Failed to save language preference:', error);
      }
    }
  };

  return (
    <>
      <Tooltip title={t('common.language')}>
        <IconButton
          color="inherit"
          onClick={handleClick}
          aria-label="change language"
        >
          <LanguageIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => changeLanguage('en')}
          selected={i18n.language === 'en'}
        >
          {t('common.english')} (English)
        </MenuItem>
        <MenuItem
          onClick={() => changeLanguage('es')}
          selected={i18n.language === 'es'}
        >
          {t('common.spanish')} (Español)
        </MenuItem>
      </Menu>
    </>
  );
}
